import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  // Transfer the server's React Query cache to the client (dehydrate/rehydrate
  // + streaming). Without this, queries that resolve during SSR streaming are
  // rendered into the HTML but the client starts with an empty cache, producing
  // a hydration mismatch (server shows product cards, client shows skeletons).
  setupRouterSsrQueryIntegration({ router, queryClient });

  return router;
};
